import { Factory } from 'rosie';

Factory.define('FbPageAccountContent');

Factory.define('FbPageAccountContentWithDefaults')
  .extend('FbPageAccountContent')
  .attr('id', 'some-fb-page-account-id')
  .attr('name', 'example-fb-page-name')
  .attr('isTemporaryToken', true);



// WEBPACK FOOTER //
// ./factories/fb_page_account_content_factory.js